import React, { useRef } from "react";
import "normalize.css";
import "./index.css";
import ReactLenis from "lenis/react";
import Header from "./components/header/Header";
import Nav from "./components/nav/Nav";
import About from "./components/about/About";
import Experience from "./components/experience/Experience";
import Certifications from "./components/certifications/Certifications";
import Services from "./components/services/Services";
import Portfolio from "./components/portfolio/Portfolio";
// import Testimonials from "./components/testimonials/Testimonials";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";

const App = () => {
  const lenisRef = useRef(null);

  return (
    <ReactLenis
      root
      ref={lenisRef}
      options={{
        lerp: 0.08,
        smoothWheel: true,
        smoothTouch: false, // important for mobile
      }}
    >
      <Header />
      <Nav rootLenisRef={lenisRef} />
      <About />
      <Experience />
      <Certifications />
      <Services />
      <Portfolio />
      {/* <Testimonials /> */}
      <Contact />
      <Footer />
    </ReactLenis>
  );
};

export default App;
